/* eslint-disable @typescript-eslint/indent */
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { styles } from '@sdir/sds';

export const Card: FC<{
  children: any;
  heading?: string;
  htmlHeading?: ReactNode;
  inverted?: boolean;
  className?: string;
  accent?: boolean;
}> = ({ children, heading, inverted, className, accent, htmlHeading }) => {
  return (
    <CardContainer inverted={inverted} className={className} accent={accent}>
      {(heading || htmlHeading) && (
        <CardHeading className="card__heading" inverted={inverted}>
          {htmlHeading || heading}
        </CardHeading>
      )}
      <div className="card__contents">{children}</div>
    </CardContainer>
  );
};

const CardHeading = styled.h3<{ inverted?: boolean }>`
  font-size: 24px;
  margin-top: 0;
  color: ${({ inverted }) => (inverted ? 'white' : 'black')};
  & * {
    font-size: 24px;
  }
`;

const CardContainer = styled.div<{ inverted?: boolean; accent?: boolean }>`
  box-shadow: ${styles.card.boxShadow};
  border-radius: ${styles.card.borderRadius};
  background: ${({ inverted, accent }) =>
    inverted
      ? styles.colors.background.blue
      : accent
      ? styles.colors.primary10
      : styles.colors.background.secondary};
  color: ${({ inverted }) => (inverted ? 'white' : 'black')};
  padding: 32px;
`;
